export const countdownIntlIds = {
  progressive: {
    label: 'countdownIntlIds.progressive.label',
  },
  regressive: {
    label: 'countdownIntlIds.regressive.label',
  },
};
